import {
  getLeoUuid,
  LeoUUID,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class VerifyFileUploadRPC implements
  LeoRPC<VerifyFileUploadRPC.Request, VerifyFileUploadRPC.Response, VerifyFileUploadRPC.Errors.Errors>
{
  abstract execute(
    request: VerifyFileUploadRPC.Request
  ): Promise<LeoRPCResult<VerifyFileUploadRPC.Response, VerifyFileUploadRPC.Errors.Errors>>;
}

export namespace VerifyFileUploadRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    fileId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isVerifyFileUploadRPCRequest: boolean = true;
  
    readonly fileId: LeoUUID;
  
  
    constructor(
    fileId: LeoUUID
    ) {
      this.fileId = fileId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const fileId = getLeoUuid(dto, "fileId", InvalidRequestFileIdError);
      return new Request(
        fileId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          fileId: this.fileId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `VerifyFileUploadRPC(fileId='${this.fileId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `VerifyFileUploadRPC.Response()`;
  };

  export enum RPCError {
    FileIdNotFound = "FILE_ID_NOT_FOUND"
  }

  export namespace Errors {
    
    export interface FileIdNotFoundDTO {
      code: string;
    }
    
    export class FileIdNotFound extends LeoRPCError<RPCError> {
      readonly isFileIdNotFound: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.FileIdNotFound;
        super(code);
      }
    
    
      toDTO(): FileIdNotFoundDTO {
        const dto: FileIdNotFoundDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    FileIdNotFound.prototype.toString = function toString(): string {
      return `VerifyFileUploadRPC.FILE_ID_NOT_FOUND()`;
    };
    

    export type Errors = FileIdNotFound;
    export type ErrorsDTO = FileIdNotFoundDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.FileIdNotFound:
          return new FileIdNotFound();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestFileIdError extends VerifyFileUploadRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestFileIdError";
  }
}


export class InvalidResponseFileIdNotFoundError extends VerifyFileUploadRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseFileIdNotFoundError";
  }
}

